import { Dropdown, assets } from '@round/whitelabel-ui';
import styles from './ActionsCell.module.css';
import { CampaignsTableMeta } from 'Modules/Plans/Campaigns/types';
import { CellContext } from '@tanstack/react-table';
import { getTableMetaHelper, Skeleton } from '@round/ui-kit';
import { useState } from 'react';
import { CampaignTableRow } from '../ReportCampaignsTable';
import useCopyReport from '../../hooks/useCopyReport';

const { Copy: CopyIcon } = assets;

export type ActionsCellMeta = CampaignsTableMeta<CampaignTableRow>;
const getTableMeta = getTableMetaHelper<ActionsCellMeta>();

type Props = CellContext<CampaignTableRow, any>;

const ActionsCell = ({ table, row: { original } }: Props) => {
    const { isLoading, getIsCampaignStatsLoading } = getTableMeta(table);
    const [isCopyLoading, setIsCopyLoading] = useState(false);
    const copyReport = useCopyReport(original);

    if (isLoading || getIsCampaignStatsLoading?.(original)) {
        return <Skeleton />;
    }

    return (
        <Dropdown>
            {({ setIsOpen }) => (
                <>
                    <Dropdown.Target />
                    <Dropdown.Menu>
                        <span className={styles.copyMenuTitle}>Copy</span>
                        <Dropdown.Item
                            icon={() => <CopyIcon className={styles.copyIcon} />}
                            onClick={() => {
                                if (!copyReport) {
                                    return;
                                }

                                setIsCopyLoading(true);
                                copyReport().finally(() => {
                                    setIsOpen(false);
                                    setIsCopyLoading(false);
                                });
                            }}
                        >
                            {isCopyLoading ? 'Report loading...' : 'Report'}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </>
            )}
        </Dropdown>
    );
};

export default ActionsCell;
